import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelpComponent } from '../dialog-help/dialog-help.component';
@Component({
  selector: 'nsc-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss']
})
export class CardTitleComponent implements OnInit {
  @Input('error') error: string;
  @Input('note') note: string;
  @Input('title') title: string;
  @Input('shoppingCartCount') shoppingCartCount: number;
  @Input('icon') icon: string;
  @Input('id') id: string;

  @Input('helpText') helpText: string;
  @Input('helpTitle') helpTitle: string;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  openHelpDialog(): void {
    this.dialog.open(DialogHelpComponent, {
      width: '490px',
      autoFocus: false,
      ariaLabelledBy: 'modalHelpTitle',
      ariaDescribedBy: 'modalHelpContent',
      id: 'modalHelp',
      data: {
        title: this.helpTitle,
        body: this.helpText,
        id: 'modalHelp'
      }
    });
  }
}